import { SvgIcon, type SvgIconProps } from '@mui/material';

/**
 * Custom brand SVG icons for visual distinction.
 *
 * These replace generic MUI icons for key navigation and brand surfaces.
 * Each icon is a zero-dependency inline SVG that inherits color via
 * `currentColor` and respects MUI's SvgIcon sizing.
 */

/** BrandLogoIcon — the Gharbatai mark: ascending chart line in a rounded square. */
export function BrandLogoIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <rect x="2" y="2" width="20" height="20" rx="5" fill="currentColor" fillOpacity={0.1} />
      <path
        d="M6 16L10 11L13 14L18 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="18" cy="7" r="1.5" fill="currentColor" />
    </SvgIcon>
  );
}

/** BrandDashboardIcon — portfolio grid with an upward trend bar. */
export function BrandDashboardIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <rect x="3" y="3" width="8" height="8" rx="2" fill="currentColor" fillOpacity={0.15} stroke="currentColor" strokeWidth="1.5" />
      <rect x="13" y="3" width="8" height="5" rx="2" fill="currentColor" fillOpacity={0.15} stroke="currentColor" strokeWidth="1.5" />
      <rect x="13" y="11" width="8" height="10" rx="2" fill="currentColor" fillOpacity={0.15} stroke="currentColor" strokeWidth="1.5" />
      <rect x="3" y="14" width="8" height="7" rx="2" fill="currentColor" fillOpacity={0.15} stroke="currentColor" strokeWidth="1.5" />
      <path d="M5 19L7 16L9 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </SvgIcon>
  );
}

/** BrandSettingsIcon — gear with a distinctive inner hexagon. */
export function BrandSettingsIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M12 2L13.5 4.5L16.5 4L17 7L20 8L19 11L21 13L19 15L20 18L17 19L16.5 22L13.5 21.5L12 24L10.5 21.5L7.5 22L7 19L4 18L5 15L3 13L5 11L4 8L7 7L7.5 4L10.5 4.5L12 2Z"
        fill="currentColor"
        fillOpacity={0.1}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12 8L14 10L14 13L12 15L10 13L10 10L12 8Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

/** BrandPortfolioIcon — stacked bars representing holdings. */
export function BrandPortfolioIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <rect x="3" y="14" width="4" height="7" rx="1" fill="currentColor" fillOpacity={0.3} stroke="currentColor" strokeWidth="1.5" />
      <rect x="10" y="9" width="4" height="12" rx="1" fill="currentColor" fillOpacity={0.5} stroke="currentColor" strokeWidth="1.5" />
      <rect x="17" y="4" width="4" height="17" rx="1" fill="currentColor" fillOpacity={0.7} stroke="currentColor" strokeWidth="1.5" />
    </SvgIcon>
  );
}
